// extracted by mini-css-extract-plugin
export default {"buttonMain":"RewardsPageMenuItem_buttonMain__mDg4v","buttonSelected":"RewardsPageMenuItem_buttonSelected__oZlUd","title":"RewardsPageMenuItem_title__fzU1Q"};